import { css } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import { MOBILE } from '../../../utils/constants';

interface Props {
  views: number;
  comments: number;
  likes: number;
  author: string;
  timeAgo: string;
}

const PostMetadata = ({ views, comments, likes, author, timeAgo }: Props) => {
  return (
    <div css={metadataStyles} data-testid="post-metadata">
      <span css={viewsStyles}>
        {views} {'views'}
      </span>
      <span css={engagementStyles}>
        <span css={iconStyles}>{'💬'}</span>
        <span>{comments}</span>
      </span>
      <span css={engagementStyles}>
        <span css={iconStyles}>{'👍'}</span>
        <span>{likes}</span>
      </span>
      <span css={authorStyles}>
        <span css={iconStyles}>{'👤'}</span>
        <a
          href={`/profile/${encodeURIComponent(author)}`}
          css={authorLinkStyles}
          onClick={(e) => e.preventDefault()} // Prevent navigation for now
        >
          {author}
        </a>
      </span>
      <span css={timeStyles}>
        <span css={iconStyles}>{'🕒'}</span>
        <span>{timeAgo}</span>
      </span>
    </div>
  );
};

const metadataStyles = css({
  display: 'flex',
  alignItems: 'center',
  gap: '16px',
  fontSize: '12px',
  color: token('color.text.subtle'),
  marginBottom: '12px',
  fontFamily: 'Inter, sans-serif',
  [MOBILE.MEDIA_QUERY]: {
    gap: '12px',
    fontSize: '11px',
  },
});

const viewsStyles = css({
  fontWeight: 500,
});

const engagementStyles = css({
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
});

const authorStyles = css({
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
  fontWeight: 500,
});

const authorLinkStyles = css({
  color: token('color.text.subtle'),
  textDecoration: 'none',
  fontWeight: 500,
  '&:hover': {
    color: token('color.text.subtle'),
    textDecoration: 'underline',
    textDecorationColor: token('color.text.subtle'),
  },
  '&:visited': {
    color: token('color.text.subtle'),
    textDecoration: 'none',
  },
});

const timeStyles = css({
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
});

const iconStyles = css({
  fontSize: '12px',
  [MOBILE.MEDIA_QUERY]: {
    fontSize: '11px',
  },
});

export default PostMetadata;
